import { connect } from 'react-redux';
import MerchantFees from 'components/fees/MerchantFees';
import {
  fetchMerchantFeesData,
  clearMerchantFeesData,
  updateMerchantFeesData,
} from 'data/fees/Fees.actions';

import ReduxHelper from 'lib/ReduxHelper';

const mapStateToProps = (state, ownProps) => {
  return ReduxHelper.mapStateWithLookups(
    {
      fees: state.fees.merchantsFeesData,
      updateMerchantsFeesData: state.fees.updateMerchantsFeesData,
      hasError:
        state.fees.merchantsFeesDataError != null ||
        state.fees.updateMerchantsFeesDataError != null,
      loading:
        state.fees.fetchingMerchantsFeesData ||
        state.fees.updatingMerchantsFeesData,
      user: state.app.user,
      userParty: state.app.userParty,
    },
    state,
    'memberships',
    'partyTypes'
  );
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchData: merchantID => {
      dispatch(fetchMerchantFeesData({ merchantID }));
    },
    clearData: () => {
      dispatch(clearMerchantFeesData());
    },
    updateFees: (feeIDs, isPaid) => {
      dispatch(updateMerchantFeesData(feeIDs, isPaid));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MerchantFees);
